//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import dayjs from 'dayjs';
import socketIoClient from 'socket.io-client';
import Nav from './Nav';
import Pane from './Pane';
import Message from './Message';
import Emoji from '~/components/emoji/emoji';
import { emoji } from '~/utils/emoji';
import portal from '~/net/portal';
import { Area } from '~/constant/Area';
import { getCookie } from '~/utils/cookie';
import config from '~/config';
import './style.scss';

const picturnSuffix = ['.jp2', '.jpeg', '.jpe', '.jpg', '.png', '.svg'];

export default {
  name: 'Courier',
  components: {
    Nav,
    Pane,
    Emoji,
    Message,
  },
  props: {
    clientType: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState(['user', 'courier']),
  },
  data() {
    return {
      restart: false,
      socket: null,

      id: '',
      outId: '',
      type: '',
      phone: '',
      name: '',
      headUrl: '',
      tenantCode: '',
      member: {},
      members: {},
      visitorIds: [],
      visitors: {},
      messageMapper: {},
      noMoreMapper: {},
      textMapper: {},

      activeId: '-1',
      paneUpdater: {
        v: 0,
      },
      size: 100,

      paneMaskVisible: false,
      showEmoji: false,
      emojiMask: false,
      history: {
        visible: false,
        name: '',
        noMore: false,
        visitorId: '',
        preId: '',
        headUrl: '',
        size: 100,
        messages: [],
      },
      wsServerUrl: '',
    };
  },
  watch: {
    'courier.chatApply'(newVal) {
      if (this.clientType === newVal.clientType) {
        if (newVal.visitorType.includes('4')) {
          this.consultAdmin();
        }
        if (newVal.visitorType.includes('2') || newVal.visitorType.includes('3')) {
          this.consultShop();
        }
      }
    },
    user() {
      this.$store.dispatch('restartCourier');
    },
    'courier.restart'() {
      setTimeout(this.restartClient, 1000);
    },
  },
  mounted() {
    this.wsServerUrl = config.chatUrl;
    this.initialize();
  },
  methods: {
    restartClient() {
      this.restart = true;
      if (this.socket) {
        this.socket.disconnect();
        this.socket = null;
      }
      this.id = '';
      this.outId = '';
      this.type = '';
      this.phone = '';
      this.name = '';
      this.headUrl = '';
      this.tenantCode = '';
      this.member = {};
      this.members = {};
      this.visitorIds = [];
      this.visitors = [];
      this.messageMapper = {};
      this.noMoreMapper = {};
      this.textMapper = {};
      this.activeId = '-1';
      this.paneUpdater = {
        v: 0,
      };
      this.paneMaskVisible = false;
      this.showEmoji = false;
      this.emojiMask = false;

      this.history.visible = false;
      this.history.name = '';
      this.history.noMore = false;
      this.history.visitorId = '';
      this.history.preId = '';
      this.history.headUrl = '';
      this.history.messages = [];

      this.initialize();
    },

    setError() {
      this.$store.dispatch('setCourierStatus', {
        type: this.clientType,
        status: { error: true },
      });
    },

    setSuccess() {
      this.$store.dispatch('setCourierStatus', {
        type: this.clientType,
        status: {
          success: true,
          type: this.type,
        },
      });
    },

    initialize() {
      if (this.clientType === 'user') {
        this.initializeUserCourier();
      } else if (this.clientType === 'shop') {
        this.initializeShopCourier();
      }
    },

    initializeUserCourier() {
      const query = {};
      if (this.user && this.user.id) {
        query.userId = this.user.id;
        query.type = '1';
        query.tenantCode = this.user.tenantCode;
      } else {
        const areaCode = this.$config.AREA_CODE;
        const selectedArea = Area.find((_) => _.areacode === areaCode);
        query.type = '0';
        query.tenantCode = selectedArea.tenantCode;
      }

      portal.getClient({ query }).then(({ code, data }) => {
        if (code !== '0000') {
          this.error = true;
        }
        if (code === '0000') {
          this.id = data.id;
          this.outId = data.outId;
          this.type = data.type;
          this.phone = data.phone;
          this.name = data.name;
          this.headUrl = data.headUrl;
          this.tenantCode = data.tenantCode;
          this.visitorIds = data.visitorIds || [];
          this.visitors = data.visitors || {};

          this.$store.dispatch('setCourierUnreadCount', {
            type: this.clientType,
            count: data.unreadCount,
          });

          this.handleSocket();

          // 新增存储游客id
          const strCookie = document.cookie;
          const cookies = strCookie.split(' ');
          let touristId = '';
          cookies.map((str) => {
            if (str.includes('NW_TOURIST_ID')) {
              const tempArr = str.split('=');
              touristId = tempArr[1];

              if (touristId.indexOf(';') > 0) {
                touristId = touristId.substring(0, touristId.length - 1);
              }
              localStorage.setItem('TOURIST_ID', touristId);
            }
          });
        }
      });
    },

    initializeShopCourier() {
      if (!this.user || !this.user.id) {
        this.setError();
        return;
      }

      let shopType;
      if (this.user.userType === 1) {
        shopType = '2';
      } else if (this.user.userType === 2) {
        shopType = '3';
      } else {
        return this.setError();
      }

      portal
        .getShopDetail()
        .then((shop) => {
          if (shop.code !== '0000' || !shop.data || !shop.data.id) {
            this.setError();
            return;
          }

          portal
            .getClientByShop({
              query: {
                shopId: shop.data.id,
                type: shopType,
                userId: this.user.id,
                tenantCode: this.user.tenantCode,
              },
            })
            .then(({ code, data }) => {
              if (code !== '0000') {
                this.setError();
                return;
              }
              this.shop = Object.assign({}, data);
              this.$store.dispatch('setCourierStatus', {
                type: this.clientType,
                status: {
                  shop: data,
                },
              });

              this.id = data.id;
              this.outId = data.outId;
              this.type = data.type;
              this.phone = data.phone;
              this.name = data.name;
              this.headUrl = data.headUrl;
              this.tenantCode = data.tenantCode;
              this.member = data.visitorIds || [];
              this.members = data.visitors || {};
              this.visitorIds = data.visitorIds || [];
              this.visitors = data.visitors || {};

              this.$store.dispatch('setCourierUnreadCount', {
                type: this.clientType,
                count: data.unreadCount,
              });
              this.handleSocket();
            })
            .catch((error) => {
              console.log(error);
              this.setError();
            });
        })
        .catch((error) => {
          console.log(error);
          this.setError();
        });
    },

    handleSocket() {
      console.log(this.wsServerUrl);
      const socketUrl = `${this.wsServerUrl}/communication?clientId=${this.id}&type=${this.type}`;
      this.socket = socketIoClient(socketUrl, {
        reconnectionAttempts: 5,
      });

      if (this.socket == null) {
        return this.setError();
      }

      this.socket.on('greetings', (isConnected) => {
        if (isConnected) {
          this.setSuccess();
        } else {
          this.setError();
        }
      });

      this.socket.on('disconnect', () => {
        if (!this.restart) {
          this.setError();
        }
        this.restart = false;
      });

      this.socket.on(this.id + '', (message) => {
        console.log(message.sendTime);
        if (typeof message.sendTime === 'number') {
          console.log(message.sendTime);
          message.sendTime = dayjs(message.sendTime).format('YYYY-MM-DD HH:mm:ss');
        }

        let visitorId;
        if (message.from === this.id) {
          visitorId = message.to;
        }
        if (message.to === this.id) {
          visitorId = message.from;
        }

        if (!this.courier[this.clientType].visible || this.activeId !== visitorId) {
          const unreadCount = this.visitors[visitorId].unreadCount;
          this.visitors[visitorId].unreadCount = unreadCount - 0 + 1 + '';
          this.$store.dispatch('plusCourierUnreadCount', this.clientType);
        }

        if (visitorId) {
          if (!this.messageMapper[visitorId]) {
            this.initializeVisitorMessages(visitorId);
          } else {
            this.appendMessages(visitorId, [message]);
          }
        }
        console.log(this.courier);
      });

      this.socket.on('read-' + this.id, (message) => {
        const { visitorId } = message;
        const clientUnreadCount = this.courier[this.clientType].unreadCount;
        const unreadCount = this.visitors[visitorId].unreadCount;
        this.visitors[visitorId].unreadCount = '0';
        const result = clientUnreadCount - 0 - (unreadCount - 0);
        this.$store.dispatch('setCourierUnreadCount', {
          type: this.clientType,
          count: result >= 0 ? result + '' : '0',
        });
      });
    },

    initializeVisitorMessages(visitorId) {
      if (!this.messageMapper[visitorId]) {
        this.messageMapper[visitorId] = [];
      }
      this.getMessages(visitorId, true);
    },

    consultAdmin() {
      portal
        .consultAdmin({
          query: {
            clientId: this.id,
            tenantCode: 'js_province',
          },
        })
        .then(({ code, data }) => {
          if (code === '0000') {
            this.addVisitor(data);
          } else {
            this.$Message.error('咨询失败，客服系统异常。');
          }
        })
        .catch((e) => {
          console.log(e);
          this.$Message.error('咨询失败，客服系统异常。');
        });
    },

    consultShop() {
      portal
        .consultShop({
          query: {
            clientId: this.id,
            shopId: this.courier.chatApply.shopId,
          },
        })
        .then(({ code, data }) => {
          if (code === '0000') {
            this.addVisitor(data);
          } else {
            this.$Message.error('咨询失败，客服系统异常。');
          }
        })
        .catch((e) => {
          console.log(e);
          this.$Message.error('咨询失败，客服系统异常。');
        });
    },

    addVisitor(visitor) {
      const { visitorIds, visitors } = this;
      const index = visitorIds.indexOf(visitor.visitorId);
      if (index === -1) {
        visitorIds.unshift(visitor.visitorId);
        visitors[visitor.visitorId] = visitor;
      } else if (index !== 0) {
        visitorIds.splice(index, 1);
        visitorIds.unshift(visitor.visitorId);
      }
      visitors[visitor.visitorId] = visitor;
      this.setActiveId(visitor.visitorId);
    },

    getHistoryMessages() {
      const query = {
        clientId: this.id,
        visitorId: this.history.visitorId,
        size: this.history.size,
      };

      if (this.history.messages.length > 0) {
        query.beforeId = this.history.messages[0].id;
      }

      portal
        .getMessages({ query })
        .then(({ code, data }) => {
          if (code !== '0000') {
            return this.$Message.error('查询历史记录失败。');
          }
          const first = this.history.messages.length === 0;
          const body = this.$refs.historyBody;
          if (first) {
            data.forEach((message) => {
              this.history.messages.push(message);
            });
            setTimeout(() => {
              body.scrollTop = body.scrollHeight;
            }, 200);
          } else {
            data.reverse().forEach((message) => {
              this.history.messages.unshift(message);
            });
            const preEle = this.$refs[`historyMsg-${this.history.preId}`][0].$el;
            body.scrollTop = preEle.offsetTop;
          }
          this.history.preId = this.history.messages[0] ? this.history.messages[0].id : '';
          this.history.noMore = data.length < this.history.size;
          if (!this.history.scrollable) {
            this.history.scrollable = true;
          }
        })
        .catch((error) => {
          console.log(error);
          this.$Message.error('查询历史记录失败。');
        });
    },

    getMessages(visitorId, append) {
      const { id, messageMapper, noMoreMapper } = this;
      const query = {
        clientId: id,
        visitorId,
        size: this.size,
      };

      if (messageMapper[visitorId].length > 0) {
        query.beforeId = this.messageMapper[visitorId][0].id;
      }

      this.paneMaskVisible = true;

      portal
        .getMessages({ query })
        .then(({ code, data, message }) => {
          if (code !== '0000') {
            this.$Message.error(message || '客服系统异常。');
            return;
          }
          if (data.length < this.size) {
            noMoreMapper[visitorId] = true;
          }

          if (data.length === 0) {
            this.paneMaskVisible = false;
            return;
          }

          if (append) {
            this.appendMessages(visitorId, data);
          } else {
            this.unshiftMessages(visitorId, data);
          }

          this.paneMaskVisible = false;
        })
        .catch((e) => {
          console.error(e);
          this.$Message.error('客服系统异常。');
        });
    },

    appendMessages(visitorId, messages) {
      let isRead = true;
      messages.forEach((message) => {
        if (isRead && !message.isRead) {
          isRead = false;
        }

        const messageList = this.messageMapper[visitorId];
        if (messageList[messageList.length] && messageList[messageList.length].id >= message.id) {
          return;
        }
        this.messageMapper[visitorId].push(message);
      });
      if (this.activeId === visitorId && !isRead && this?.courier[this?.clientType]?.visible) {
        this.readMessages(visitorId);
      }
      this.updatePane(visitorId, true);
    },

    readMessages(visitorId) {
      this.socket.emit('read', { clientId: this.id, visitorId });
    },

    unshiftMessages(visitorId, messages) {
      messages.reverse().forEach((message) => {
        this.messageMapper[visitorId].unshift(message);
      });
      this.updatePane(visitorId, false);
    },

    updatePane(visitorId, scrollToBottom) {
      const v = this.paneUpdater.v;
      this.paneUpdater = {
        v: v + 1 === 100 ? 0 : v + 1,
        visitorId,
        scrollToBottom,
      };
    },

    setActiveId(visitorId) {
      this.activeId = visitorId;
      const { messageMapper } = this;
      if (!messageMapper[visitorId]) {
        this.initializeVisitorMessages(visitorId);
      } else {
        this.updatePane(visitorId, false);
      }
      if (this.textMapper[visitorId] === undefined) {
        this.textMapper[visitorId] = '';
      }
      if (this.visitors[visitorId].unreadCount !== '0') {
        this.readMessages(visitorId);
      }
      this.$store.dispatch('setCourierVisitorType', this.clientType);
      this.$store.dispatch('setCourierStatus', {
        type: this.clientType,
        status: {
          visible: true,
        },
      });
    },

    handleClose() {
      this.$store.dispatch('setCourierStatus', {
        type: this.clientType,
        status: {
          visible: false,
        },
      });
    },

    handleEmojiClick() {
      this.showEmoji = !this.showEmoji;
      if (this.showEmoji) {
        this.emojiMask = true;
      }
    },

    handlePictureClick() {
      if (!this.user) {
        return this.$Message.warning('游客不允许发送图片和文件，请登录。');
      }
      this.$refs.pictureInput.click();
    },

    handlePictureChange(e) {
      const fileObj = e.target.files[0];
      if (fileObj) {
        const suffixes = fileObj.name.split('.');
        if (!picturnSuffix.includes(`.${suffixes[suffixes.length - 1]}`)) {
          e.target.value = '';
          return this.$Message.error(`请选择${picturnSuffix.join('、')}类型的图片。`);
        }
        const param = new FormData();
        param.append('file', fileObj);
        this.upload(param, '2');
        e.target.value = '';
      }
    },

    handleFileClick() {
      if (!this.user) {
        return this.$Message.warning('游客不允许发送图片和文件，请登录。');
      }
      this.$refs.fileInput.click();
    },

    handleFileChange(e) {
      const fileObj = e.target.files[0];
      if (fileObj) {
        const param = new FormData();
        param.append('file', fileObj);
        this.upload(param, '3');
        e.target.value = '';
      }
    },

    upload(param, type) {
      portal
        .upload({
          body: param,
        })
        .then((res) => {
          const { code, data, message } = res;
          if (code !== '0000') {
            this.$Message.error(message || '发送失败。');
          }

          const msg = {
            memberId: this.id,
            from: this.id,
            to: this.activeId,
            type,
            content: data.url,
            fileName: data.original,
          };
          this.socket.emit('message', msg, (res) => {
            this.textMapper[this.activeId] = '';
            if (typeof res.data.sendTime === 'number') {
              res.data.sendTime = dayjs(res.data.sendTime).format('YYYY-MM-DD hh:mm:ss');
            }
            this.appendMessages(this.activeId, [res.data]);
            this.$refs.textarea.focus();
          });
        })
        .catch((err) => {
          console.error(err);
          this.$Message.error('发送失败。');
        });
    },

    handleEmojiMaskClick() {
      if (this.showEmoji) {
        this.showEmoji = false;
        this.emojiMask = false;
      }
    },

    selectEmoji(val) {
      if (!this.textMapper[this.activeId]) {
        this.textMapper[this.activeId] = val;
      } else {
        this.textMapper[this.activeId] += val;
      }
      this.showEmoji = false;
      this.emojiMask = false;
    },

    handleHistoryClick() {
      const visitor = this.visitors[this.activeId];
      this.history.visitorId = visitor.visitorId;
      this.history.noMore = false;
      this.history.preId = '';
      this.history.name = visitor.visitorName || visitor.visitorPhone;
      this.history.headUrl = visitor.visitorHeadUrl || require('~/assets/images/head.png');
      this.history.messages = [];
      this.history.scrollable = false;
      this.getHistoryMessages();
      this.history.visible = true;
    },

    handleHistoryScroll(e) {
      const ele = e.target;
      if (!this.history.noMore && ele.scrollTop === 0 && this.history.scrollable) {
        this.getHistoryMessages();
      }
    },

    handleSendClick() {
      const content = this.textMapper[this.activeId];
      if (content && content.length > 0) {
        const msg = {
          memberId: this.clientType === 'shop' ? this.member.id : this.id,
          from: this.id,
          to: this.activeId,
          type: '1',
          content,
        };
        this.socket.emit('message', msg, (res) => {
          this.textMapper[this.activeId] = '';
          if (typeof res.data.sendTime === 'number') {
            res.data.sendTime = dayjs(res.data.sendTime).format('YYYY-MM-DD HH:mm:ss');
          }
          if (
            this.messageMapper[this.activeId] &&
            this.messageMapper[this.activeId].find((m) => res.data.id === m.id)
          ) {
            return;
          }
          this.appendMessages(this.activeId, [res.data]);
          this.$refs.textarea.focus();
        });
      } else {
        this.$Message.error('发送消息不能为空。');
      }
    },

    togglePaneMaskVisible(visibility) {
      this.paneMaskVisible = visibility;
    },

    handleMouseEnter() {
      this.$bus.$emit('disableScroll');
    },

    handleMouseLeave() {
      this.$bus.$emit('enableScroll');
    },

    removeVisitor(visitorId) {
      portal
        .deleteVisitor({
          query: { clientId: this.id, visitorId },
        })
        .then((res) => {
          if (res.code !== '0000') {
            return this.$Message.error('服务异常，删除失败。');
          }
          this.visitorIds.splice(this.visitorIds.findIndex((id) => id === visitorId), 1);
          delete this.visitors[visitorId];
          delete this.messageMapper[visitorId];
          delete this.textMapper[visitorId];
          if (this.visitorIds.length === 0) {
            this.activeId = '-1';
            return this.handleClose();
          }
          if (this.activeId === visitorId) {
            this.setActiveId(this.visitorIds[0]);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$Message.error('服务异常，删除失败。');
        });
    },
  },
};
